import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

function Navigation({ isAuthenticated, isAdmin, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    onLogout();
    setIsOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo">
          <span className="logo-text">Remu Bucket Portal</span>
        </Link>
        
        <button type="button" className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className={`hamburger ${isOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/connect" className="nav-link" onClick={() => setIsOpen(false)}>
              Connect
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/monitoring" className="nav-link" onClick={() => setIsOpen(false)}>
              Monitoring
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/reporting" className="nav-link" onClick={() => setIsOpen(false)}>
              Reporting
            </Link>
          </li>
          {isAdmin && (
            <li className="nav-item">
              <Link to="/manage" className="nav-link" onClick={() => setIsOpen(false)}>
                Manage
              </Link>
            </li>
          )}
          <li className="nav-item">
            {isAuthenticated ? (
              <button type="button" className="nav-link nav-button" onClick={handleLogout}>
                Logout
              </button>
            ) : (
              <Link to="/login" className="nav-link" onClick={() => setIsOpen(false)}>
                Login
              </Link>
            )}
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navigation;
